import React from 'react';
import { Skeleton, Stack } from '@mui/material';
import styles from './scss/jobCardSkeleton.module.scss';

function JobCardSkeleton() {
  return (
    <div className={`${styles.JobCard}`}>
      <Stack spacing={1}>
        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="rectangular" width="100%" height={60} />
      </Stack>
    </div>
  );
}

export default JobCardSkeleton;
